import React, { useCallback, useState } from 'react'

import { Image } from '../Common/Image';
import { RichText } from '../../richTextOptions';
import Cookies from 'js-cookie';
import dayjs from 'dayjs';
import axios from 'axios';

const WackyStory = ({ story }) => {
    const { category } = story;
    let listStoriesInCategory = category.wacky_pet___story;
    let categorySlug = '/wackypetnames/' + category.slug + '/';
    let isVotingOn =
        story.turnOnVotingForThisStory ||
        (category.turnOnVotingForThisCategory && (story.turnOnVotingForThisStory !== false)); // story option overrides category option
    let petType = category.slug.toLowerCase().includes('dog') ? 'dog' : 'cat';
    const COOKIE_NAME = (petType === 'dog') ? 'dog_voting_visitor' : 'cat_voting_visitor';
    const DAYS_TO_EXPIRE = 1;
    const [isVoted, setIsVoted] = useState(!!Cookies.get(COOKIE_NAME));
    const petName = story.petName || story.title;
    const replacePetName = useCallback((string) => {
        return string.replace(/##wackypetname##/gi, petName.toUpperCase());
    }, [])

    const guid = useCallback(() => {
        const s4 = () => {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }, [])

    if (isVotingOn) {
        let votingButtonSet = true;
        let enabledText = '';
        let disabledText = '';
        let salesforceUrl = '';

        if (story.votingButton) {
            enabledText = replacePetName(story.votingButton.enabledText);
            disabledText = replacePetName(story.votingButton.disabledText);
            salesforceUrl = story.votingButton.salesforceUrl;
        } else if (category.votingButton) {
            enabledText = replacePetName(category.votingButton.enabledText);
            disabledText = replacePetName(category.votingButton.disabledText);
            salesforceUrl = category.votingButton.salesforceUrl;
        } else {
            console.log('Please set voting button for the category which this story belongs to or for this story');
            votingButtonSet = false;
        }

        var VotingButton = () => {
            if (!votingButtonSet) {
                return <></>
            }

            const voting = (e) => {
                var votingPick = e.target.name;
                var ipAddr = '';

                axios.get('https://www.cloudflare.com/cdn-cgi/trace')
                    .then(response => {
                        if (response.status === 200) {
                            const myRegexp = /^(?:ip)=(.*)$/gm;
                            let responseString = response.data;
                            let match;

                            match = myRegexp.exec(responseString);
                            while (match != null) {
                                ipAddr = ipAddr.concat(match[1] + "\n");
                                match = myRegexp.exec(responseString);
                            }
                        } else {
                            ipAddr = guid();
                        }

                        let cookieCreateDate = dayjs();
                        let cookieExpireDate = cookieCreateDate.add(DAYS_TO_EXPIRE, 'day');
                        let cookieExpireTemp = cookieExpireDate.toISOString().slice(0, 10);

                        let cookieValue = {
                            ipAddr,
                            cookieExpireDate: cookieExpireDate.toString(),
                            votingChoice: petName,
                        }

                        //set cookie
                        Cookies.set(COOKIE_NAME, JSON.stringify(cookieValue), { expires: DAYS_TO_EXPIRE });
                        setIsVoted(true);

                        if (salesforceUrl) {
                            const questionMarkIndex = salesforceUrl.indexOf('?');
                            let paramString = (questionMarkIndex === -1) ? '' : salesforceUrl.substr(questionMarkIndex + 1);
                            var url = `${salesforceUrl}${paramString ? '&' : '?'}ipAddress=${ipAddr}cookieExpireDate${encodeURIComponent(cookieExpireTemp)}&votingPick=${encodeURIComponent(votingPick)}&votedSpecies=${petType}`;

                            axios.post(url)
                                .then(response => {
                                    console.log(response)
                                })
                            // window.location.href = url;
                        }
                    })
            }

            return (
                <>
                    {
                        isVoted ? (
                            <button className="voting-btn disabled" disabled>{disabledText}</button>
                        ) : (
                                <button className="voting-btn" name={petName} onClick={voting}>{enabledText}</button>
                            )
                    }
                </>
            )
        }
    }

    return (
        <>
            <section className="wacky-story-intro">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="avatar-pet-winner">
                                <div className="wrap">
                                    <Image image={story.image} />
                                </div>
                            </div>
                        </div>
                        <div className="col-right-container">
                            <h1>{story.title}</h1>
                            <p>{story.shortDescription}</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="wacky-story-content">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                            {isVotingOn && <VotingButton />}
                            {story.body && <RichText data={story.body} />}
                            {isVotingOn && <VotingButton />}
                        </div>
                        <div className="col-md-4">
                            <div className="list-top-pet">
                                <ul>
                                    {
                                        listStoriesInCategory && (
                                            listStoriesInCategory.map((val, i) => {
                                                if (val.id == story.id) {
                                                    return <li key={i}><a href={categorySlug + val.slug + '/'} className="active">{val.title}</a></li>
                                                }
                                                return <li key={i}><a href={categorySlug + val.slug + '/'}>{val.title}</a></li>
                                            })
                                        )
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default WackyStory;
